<div class="recommend-page" @click="closePersonDropdown">
  <div class="page-header">
    <div>
      <h2>推荐纪念人</h2>
      <p>管理平台首页推荐的纪念人，仅公开纪念人可被推荐（state=1）。</p>
    </div>
    <button type="button" class="primary-btn" :disabled="loading || saving" @click="openCreateModal">
      添加推荐
    </button>
  </div>

  <div class="filter-panel">
    <label class="filter-item">
      <span>推荐状态</span>
      <select v-model="filterState" :disabled="loading" @change="handleStateFilterChange">
        <option value="">全部</option>
        <option value="1">推荐中</option>
        <option value="0">已取消</option>
      </select>
    </label>
    <button type="button" class="secondary-btn" :disabled="loading" @click="resetFilters">重置</button>
  </div>

  <div class="table-container">
    <div v-if="loading" class="loading-wrapper">
      <div class="loading-spinner"></div>
      <span>加载中...</span>
    </div>

    <div v-else class="table-scroll">
      <table class="data-table">
        <thead>
          <tr>
            <th class="avatar-col">头像</th>
            <th>记录 ID</th>
            <th>纪念人 ID</th>
            <th>姓名</th>
            <th>公开状态</th>
            <th>推荐状态</th>
            <th>更新时间</th>
            <th class="action-col">操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="recommendList.length === 0">
            <td colspan="8" class="empty-text">暂无推荐纪念人</td>
          </tr>
          <tr v-else v-for="item in recommendList" :key="item.id">
            <td class="avatar-col">
              <img v-if="pickPersonAvatar(item)" :src="pickPersonAvatar(item)" class="avatar-thumb" alt="" />
              <span v-else class="avatar-placeholder">无</span>
            </td>
            <td>{{ item.id }}</td>
            <td>{{ pickPersonId(item) }}</td>
            <td>{{ pickPersonName(item) }}</td>
            <td>
              <span :class="pickPublicLabel(item) === '公开' ? 'public-yes' : 'public-no'">
                {{ pickPublicLabel(item) }}
              </span>
            </td>
            <td>
              <span :class="item.state === 1 ? 'state-active' : 'state-cancelled'">
                {{ pickStateLabel(item.state) }}
              </span>
            </td>
            <td>{{ formatDate(item.updated_at || item.created_at) }}</td>
            <td class="action-col">
              <button
                v-if="item.state === 1"
                type="button"
                class="action-btn cancel-btn"
                :disabled="saving"
                @click="handleToggleState(item, 0)"
              >
                取消推荐
              </button>
              <button
                v-else
                type="button"
                class="action-btn edit-btn"
                :disabled="saving"
                @click="handleToggleState(item, 1)"
              >
                重新推荐
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-if="!loading && recommendList.length > 0" class="pagination">
      <button type="button" class="page-btn" :disabled="currentPage <= 1" @click="handlePageChange(currentPage - 1)">
        上一页
      </button>
      <span class="page-info">第 {{ currentPage }} / {{ totalPages }} 页 · 共 {{ total }} 条</span>
      <button
        type="button"
        class="page-btn"
        :disabled="currentPage >= totalPages"
        @click="handlePageChange(currentPage + 1)"
      >
        下一页
      </button>
    </div>
  </div>

  <div v-if="modalVisible" class="modal-mask" @click="closeModal">
    <div class="modal-panel" @click.stop @click="closePersonDropdown">
      <div class="modal-header">
        <h3>添加推荐纪念人</h3>
        <button type="button" class="close-btn" @click="closeModal">×</button>
      </div>
      <div class="modal-body">
        <label class="form-row" @click.stop>
          <span>搜索纪念人 <em>*</em></span>
          <div class="search-picker">
            <input
              v-model="personSearchQuery"
              type="search"
              placeholder="输入纪念人姓名搜索"
              autocomplete="off"
              @input="handlePersonSearch"
              @focus="personDropdownOpen = true"
            />
            <button v-if="selectedPerson" type="button" class="clear-btn" @click="clearSelectedPerson">清除</button>
            <div
              v-if="personDropdownOpen && (personSearchLoading || personSearchResults.length > 0)"
              class="search-dropdown"
            >
              <div v-if="personSearchLoading" class="dropdown-hint">搜索中...</div>
              <button
                v-for="person in personSearchResults"
                :key="person.id"
                type="button"
                class="dropdown-item"
                @click="selectPerson(person)"
              >
                {{ person.name }}（ID: {{ person.id }}）
                <span v-if="person.is_public === false || person.is_public === 0" class="tag-private">非公开</span>
              </button>
            </div>
            <div v-if="selectedPerson" class="selected-item">
              已选：{{ selectedPerson.name }}（ID: {{ selectedPerson.id }}）
            </div>
          </div>
        </label>
        <p class="hint-text">仅公开纪念人可被推荐，非公开纪念人保存时后端会返回 400。</p>
      </div>
      <div class="modal-actions">
        <button type="button" class="secondary-btn" :disabled="saving" @click="closeModal">取消</button>
        <button type="button" class="primary-btn" :disabled="saving" @click="handleAddRecommend">
          {{ saving ? '保存中...' : '确认推荐' }}
        </button>
      </div>
    </div>
  </div>
</div>
